import React from 'react';
import {IonButton, IonCol, IonRow} from '@ionic/react';
import {
    actionToCreateMemberShipOrder, actionToGetActiveUserMembershipById,
    actionToVerifyMembershipOrderPayment
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "./Loader/FacebookLoader";
import {Capacitor} from "@capacitor/core";
import {openIosPaymentPage} from "../lib/paymentPageHelper";

let RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

export default function MemberShipCard({withoutLogin,isMobile}) {

    const { userAuthDetail,currentMemberMemberShipDetail } = useStore();
    const {userInfo,} = userAuthDetail;
    const {loading,memberShipDetail} = currentMemberMemberShipDetail;

    const handleMemberShipPurchase = async (type) => {
        try {
            // Create order on backend
            const { data } = await actionToCreateMemberShipOrder({ type });

            // If iOS → open in Safari (Apple-safe)
            if (Capacitor.getPlatform() === "ios") {
                await openIosPaymentPage(data.order.id,'membership');
                return;
            }

            // ANDROID + WEB → Use Razorpay normally
            const options = {
                key: RAZORPAY_KEY_ID,
                amount: data.order.amount,
                currency: "INR",
                name: "AICAS",
                description: data.order.description,
                order_id: data.order.id,

                prefill: {
                    name: userInfo.name,
                    email: userInfo.email,
                    contact: userInfo.phone_number
                },

                handler: async (response) => {
                    try {
                        await actionToVerifyMembershipOrderPayment(response);
                        await actionToGetActiveUserMembershipById();
                    } catch (error) {
                        console.error("Verification error:", error);
                        alert("Payment verification failed. Contact support.");
                    }
                },

                theme: {
                    color: "#3399cc",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error(err);
        }
    };


    return (
        <>
            <IonRow className={"text-left bg-blend-lighten"}>
                <IonCol sizeMd={"12"} className={"text-center"}>
                    <h1 className={"m-0 p-heading"}>Become a Member of AICAS </h1>
                    <p>All India Chartered Accountants Society provides niche membership and hence relatively closer
                        bonding, higher opportunity to interact with new and seasoned professionals with varied
                        experiences. </p>
                </IonCol>
            </IonRow>
            {(withoutLogin) ?
                <>
                    {(isMobile) ? (
                            <div className="membership-row">
                                <div className="membership-col">
                                    <div className="membership-card-custom">
                                        <h2 className="membership-type">Life Membership</h2>
                                        <div className="membership-point-mobile-container-grid">
                                            {[
                                                {label: "Who can apply", value: "Individual – CA"},
                                                {label: "Admission Fees", value: "NA"},
                                                {label: "Membership Fees", value: "₹ 25,000 + GST"},
                                                {label: "Membership Renewal", value: "NA"},
                                                {label: "Validity", value: "Life Time"},
                                                {label: "E-Newsletter Included", value: "Yes"},
                                                {label: "Discounted Event Fees", value: "Yes"},
                                                {label: "Access to ‘Members Only’ Events", value: "Yes"},
                                                {label: "Get Involved and Volunteer", value: "Yes"},
                                            ].map((item, index) => (
                                                <div className="membership-point-mobile-container-grid-row" key={index}>
                                                    <p className="membership-point">
                                                        <span className="span-1">{item.label}</span>
                                                        <span className="span-2">{item.value}</span>
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="membership-col">
                                    <div className="membership-card-custom">
                                        <h2 className="membership-type">Annual Membership</h2>
                                        <div className="membership-point-mobile-container-grid">
                                            {[
                                                {label: "Who can apply", value: "Individual – CA"},
                                                {label: "Admission Fees", value: "NA"},
                                                {label: "Membership Fees", value: "₹ 5,000 + GST"},
                                                {label: "Membership Renewal", value: "₹ 5,000 + GST"},
                                                {label: "Validity", value: "12 Months"},
                                                {label: "E-Newsletter Included", value: "Yes"},
                                                {label: "Discounted Event Fees", value: "Yes"},
                                                {label: "Access to ‘Members Only’ Events", value: "Yes"},
                                                {label: "Get Involved and Volunteer", value: "Yes"},
                                            ].map((item, index) => (
                                                <div className="membership-point-mobile-container-grid-row" key={index}>
                                                    <p className="membership-point">
                                                        <span className="span-1">{item.label}</span>
                                                        <span className="span-2">{item.value}</span>
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        :
                        (
                            <IonRow className={"mt-15"}>
                                <IonCol sizeMd={"12"} className={"text-center"}>
                                    <h4 className={"s-heading-r text-center"}>
                                        The membership can be either of Life / Annual
                                        Membership as listed below
                                    </h4>

                                    <table className="membership-table">
                                        <thead>
                                        <tr>
                                            <th>Points</th>
                                            <th>Life Membership</th>
                                            <th>Annual Membership</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td data-label={"points"}>Who can apply</td>
                                            <td data-label={"Life Membership"}>Individual – CA</td>
                                            <td data-label={"Annual Membership"}>Individual – CA</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Admission Fees</td>
                                            <td data-label={"Life Membership"}>NA</td>
                                            <td data-label={"Annual Membership"}>NA</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Membership Fees</td>
                                            <td data-label={"Life Membership"}>₹ 25,000/- + GST (One Time)</td>
                                            <td data-label={"Annual Membership"}>₹ 5,000/- + GST (Annual)</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Membership Renewal</td>
                                            <td data-label={"Life Membership"}>NA</td>
                                            <td data-label={"Annual Membership"}>₹ 5,000/- + GST (Annual)</td>

                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Validity</td>
                                            <td data-label={"Life Membership"}>Life Time</td>
                                            <td data-label={"Annual Membership"}>12 Months</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>E-Newsletter Included</td>
                                            <td data-label={"Life Membership"}>Yes</td>
                                            <td data-label={"Annual Membership"}>Yes</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Discounted Event Fees</td>
                                            <td data-label={"Life Membership"}>Yes</td>
                                            <td data-label={"Annual Membership"}>Yes</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Access to ‘Members Only’ Events</td>
                                            <td data-label={"Life Membership"}>Yes</td>
                                            <td data-label={"Annual Membership"}>Yes</td>
                                        </tr>
                                        <tr>
                                            <td data-label={"points"}>Get Involved and Volunteer</td>
                                            <td data-label={"Life Membership"}>Yes</td>
                                            <td data-label={"Annual Membership"}>Yes</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </IonCol>
                            </IonRow>
                        )}
                </>
                :
                <>
                    {(isMobile) ? (
                            <>
                                {(loading) ?
                                    <div className="membership-row">
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </div>
                                    : !memberShipDetail?.id ?
                                        <div className="membership-row">
                                            <div className="membership-col">
                                                <div className="membership-card-custom">
                                                    <h2 className="membership-type">Life Membership</h2>
                                                    <div className="membership-point-mobile-container-grid">
                                                        {[
                                                            {label: "Who can apply", value: "Individual – CA"},
                                                            {label: "Admission Fees", value: "NA"},
                                                            {label: "Membership Fees", value: "₹ 25,000 + GST"},
                                                            {label: "Membership Renewal", value: "NA"},
                                                            {label: "Validity", value: "Life Time"},
                                                            {label: "E-Newsletter Included", value: "Yes"},
                                                            {label: "Discounted Event Fees", value: "Yes"},
                                                            {label: "Access to ‘Members Only’ Events", value: "Yes"},
                                                            {label: "Get Involved and Volunteer", value: "Yes"},
                                                        ].map((item, index) => (
                                                            <div className="membership-point-mobile-container-grid-row" key={index}>
                                                                <p className="membership-point">
                                                                    <span className="span-1">{item.label}</span>
                                                                    <span className="span-2">{item.value}</span>
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <IonButton onClick={()=>handleMemberShipPurchase('Lifetime')} expand="block" className="join-now-button mt-15">
                                                        Buy Now
                                                    </IonButton>
                                                </div>
                                            </div>
                                            <div className="membership-col">
                                                <div className="membership-card-custom">
                                                    <h2 className="membership-type">Annual Membership</h2>
                                                    <div className="membership-point-mobile-container-grid">
                                                        {[
                                                            {label: "Who can apply", value: "Individual – CA"},
                                                            {label: "Admission Fees", value: "NA"},
                                                            {label: "Membership Fees", value: "₹ 5,000 + GST"},
                                                            {label: "Membership Renewal", value: "₹ 5,000 + GST"},
                                                            {label: "Validity", value: "12 Months"},
                                                            {label: "E-Newsletter Included", value: "Yes"},
                                                            {label: "Discounted Event Fees", value: "Yes"},
                                                            {label: "Access to ‘Members Only’ Events", value: "Yes"},
                                                            {label: "Get Involved and Volunteer", value: "Yes"},
                                                        ].map((item, index) => (
                                                            <div className="membership-point-mobile-container-grid-row" key={index}>
                                                                <p className="membership-point">
                                                                    <span className="span-1">{item.label}</span>
                                                                    <span className="span-2">{item.value}</span>
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <IonButton onClick={()=>handleMemberShipPurchase('Annual')} expand="block" className="join-now-button mt-15">
                                                        Buy Now
                                                    </IonButton>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="membership-active-card">
                                            <h2 className="membership-active-title">Your Active Membership</h2>
                                            <div className="membership-active-details">
                                                <p>
                                                    <strong>Type:</strong> {memberShipDetail.membership_type}
                                                </p>
                                                <p>
                                                    <strong>Start Date:</strong>{" "}
                                                    {new Date(memberShipDetail.start_date).toLocaleDateString()}
                                                </p>
                                                {memberShipDetail.membership_type === "Annual" && (
                                                    <p>
                                                        <strong>Expiry Date:</strong>{" "}
                                                        {new Date(memberShipDetail.end_date).toLocaleDateString()}
                                                    </p>
                                                )}
                                                <p>
                                                    <strong>Status:</strong>{" "}
                                                    <span className={`status-badge active`}>
                                          Active
                                        </span>
                                                </p>
                                            </div>

                                            {memberShipDetail.membership_type === "Annual" && (
                                                <IonRow>
                                                    <IonCol>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={() => handleMemberShipPurchase("Annual")}
                                                        >
                                                            Renew Membership
                                                        </IonButton>
                                                    </IonCol>
                                                    <IonCol>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={() => handleMemberShipPurchase("Lifetime")}
                                                        >
                                                            Lifetime Membership
                                                        </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            )}
                                        </div>
                                }
                            </>
                        )
                        :
                        (
                            <IonRow className={"mt-15"}>
                                {(loading) ?
                                    <IonCol>
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </IonCol>
                                    :!memberShipDetail?.id ?
                                        <IonCol sizeMd={"12"} className={"text-center"}>
                                            <h4 className={"s-heading-r text-center"}>
                                                The membership can be either of Life / Annual
                                                Membership as listed below
                                            </h4>

                                            <table className="membership-table">
                                                <thead>
                                                <tr>
                                                    <th>Points</th>
                                                    <th>Life Membership</th>
                                                    <th>Annual Membership</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td data-label={"points"}>Who can apply</td>
                                                    <td data-label={"Life Membership"}>Individual – CA</td>
                                                    <td data-label={"Annual Membership"}>Individual – CA</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Admission Fees</td>
                                                    <td data-label={"Life Membership"}>NA</td>
                                                    <td data-label={"Annual Membership"}>NA</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Membership Fees</td>
                                                    <td data-label={"Life Membership"}>₹ 25,000/- + GST (One Time)</td>
                                                    <td data-label={"Annual Membership"}>₹ 5,000/- + GST (Annual)</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Membership Renewal</td>
                                                    <td data-label={"Life Membership"}>NA</td>
                                                    <td data-label={"Annual Membership"}>₹ 5,000/- + GST (Annual)</td>

                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Validity</td>
                                                    <td data-label={"Life Membership"}>Life Time</td>
                                                    <td data-label={"Annual Membership"}>12 Months</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>E-Newsletter Included</td>
                                                    <td data-label={"Life Membership"}>Yes</td>
                                                    <td data-label={"Annual Membership"}>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Discounted Event Fees</td>
                                                    <td data-label={"Life Membership"}>Yes</td>
                                                    <td data-label={"Annual Membership"}>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Access to ‘Members Only’ Events</td>
                                                    <td data-label={"Life Membership"}>Yes</td>
                                                    <td data-label={"Annual Membership"}>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>Get Involved and Volunteer</td>
                                                    <td data-label={"Life Membership"}>Yes</td>
                                                    <td data-label={"Annual Membership"}>Yes</td>
                                                </tr>
                                                <tr>
                                                    <td data-label={"points"}>
                                                        Action
                                                    </td>
                                                    <td data-label={"Life Membership"}>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={()=>handleMemberShipPurchase('Lifetime')}
                                                        >
                                                            Buy Now
                                                        </IonButton>
                                                    </td>
                                                    <td data-label={"Annual Membership"}>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={()=>handleMemberShipPurchase('Annual')}
                                                        >
                                                            Buy Now
                                                        </IonButton>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </IonCol>
                                        :
                                        <div className="membership-active-card">
                                            <h2 className="membership-active-title">Your Active Membership</h2>
                                            <div className="membership-active-details">
                                                <p>
                                                    <strong>Type:</strong> {memberShipDetail.membership_type}
                                                </p>
                                                <p>
                                                    <strong>Start Date:</strong>{" "}
                                                    {new Date(memberShipDetail.start_date).toLocaleDateString()}
                                                </p>
                                                {memberShipDetail.membership_type === "Annual" && (
                                                    <p>
                                                        <strong>Expiry Date:</strong>{" "}
                                                        {new Date(memberShipDetail.end_date).toLocaleDateString()}
                                                    </p>
                                                )}
                                                <p>
                                                    <strong>Status:</strong>{" "}
                                                    <span className={`status-badge active`}>
                                          Active
                                        </span>
                                                </p>
                                            </div>

                                            {memberShipDetail.membership_type === "Annual" && (
                                                <IonRow>
                                                    <IonCol>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={() => handleMemberShipPurchase("Annual")}
                                                        >
                                                            Renew Membership
                                                        </IonButton>
                                                    </IonCol>
                                                    <IonCol>
                                                        <IonButton
                                                            expand="block"
                                                            className="join-now-button"
                                                            onClick={() => handleMemberShipPurchase("Lifetime")}
                                                        >
                                                            Lifetime Membership
                                                        </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            )}
                                        </div>
                                }
                            </IonRow>
                        )}
                </>
            }

        </>
    );
}
